module.exports = __webpack_public_path__ + "img/user 1.46b814f6.svg";